import {config} from "../config";
import {Image} from "../models/product";
import {ImageDisplayType, ImageResolution} from "../components/product-image";

export class ImageService {

  getImageUrlInFormat (key:string, frame: string):string {
    return `${config.imageBasePath}/image/public/${key}?res=high&frame=${frame}`;
  }

  getImagePreviewUrl (key:string):string {
    return `${config.imageBasePath}/image/public/${key}?res=low`;
  }

  getImageUrl (key:string):string {
    return `${config.imageBasePath}/image/public/${key}`;
  }

  getThumbnailUrl (key: string): string {
    return `${config.imageBasePath}/image/public/thumbnail/${key}`
  }

  getVideoUrl(key: string) {
    return `${config.imageBasePath}/video/public/${key}`;
  }

  findThumbnail(images: Image[]): string {
    let thumbnail = images.find(it => it.hasThumbnail);
    if (thumbnail) {
      return this.getThumbnailUrl(thumbnail.key);
    }
    return '';
  }

  getUrl(image: Image, resolution?: ImageResolution, displayType?: ImageDisplayType): string {
    if (!image.type) {
      return '';
    }
    if (image.type === 'OUTFIT_VIDEO') {
      return this.getVideoUrl(image.key)
    }
    if (resolution) {
      let imageUrl = `${this.getImageUrl(image.key)}?res=${resolution}`;
      if (image.type === 'OUTFIT_IMAGE') {
        imageUrl = `${this.getImageUrl(image.key)}?res=${resolution}&frame=2_3`
      }
      return imageUrl
    } else {

      if (displayType === 'preview') {
        let imageUrl =  this.getImagePreviewUrl(image.key);
        if (image.type === 'OUTFIT_IMAGE') {
          imageUrl = `${imageUrl}&frame=2_3`
        }
        return imageUrl
      } else if (displayType === 'thumbnail') {
        return this.getThumbnailUrl(image.key)
      }
      return this.getImageUrl(image.key)
    }
  }
}

export let imageService = new ImageService();